import React, { useState } from 'react';
import Select from 'common/components/form/inputs/Select';
import StyledSelect from 'common/components/form/styled-inputs/Select';

import { getAsyncOptions, getInitialAsyncValues } from 'utils/helpers';
import useFilterSelector from 'common/components/filters/useFilterSelector';

const CountrySelector = ({ filter, onChange, isMulti, styled, ...rest }) => {
  const [selectedCountries, setSelectedCountries] = useState([]);

  useFilterSelector(
    filter?.value,
    { list: 'countries' },
    { selected: selectedCountries, setSelected: setSelectedCountries }
  );

  const SelectTag = styled ? StyledSelect : Select;

  return (
    <SelectTag
      autoFocus
      placeholder="Select value"
      getOptionValue={option => option.id}
      getOptionLabel={option => option.name}
      value={
        filter?.value
          ? selectedCountries.filter(el => filter?.value.map(Number).includes(el.id))
          : []
      }
      isMulti={isMulti}
      defaultOptions={() => getInitialAsyncValues('countries')}
      isAsync
      loadOptions={search => getAsyncOptions(search, 'countries')}
      onChange={(selected, options) => {
        setSelectedCountries(selected);
        onChange(
          { value: selected ? (isMulti ? [...selected.map(s => s.id)] : selected) : '' },
          options
        );
      }}
      {...rest}
    />
  );
};

export default CountrySelector;
